// eslint-disable-next-line import/no-cycle
import commonContentFields from '../../common/contentFields';
import { FieldTypes, SettingsField } from '../../../../../../types/page-generator';

const contentFields: SettingsField[] = [
  ...commonContentFields,
  {
    name: 'actionButtons',
    type: FieldTypes.buttons,
    defaultValue: [
      {
        label: 'העלה',
        color: 'secondary',
        size: 'medium',
        variant: 'contained',
        link: '#',
      },
    ],
    rowSize: 4,
    label: 'Action Buttons',
  },
  {
    name: 'isSupplierMode',
    label: 'Supplier Mode',
    type: FieldTypes.checkbox,
    defaultValue: false,
    rowSize: 2,
  },
];

export default contentFields;
